import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import { Skeleton as MuiSkeleton } from '@material-ui/lab';
import { TextColor } from '@setvi/shared/enums';

export const Skeleton = withStyles({
  root: {
    borderRadius: 4,
    backgroundColor: 'white !important'
  }
})(MuiSkeleton);

export const BreadcrumbsWrapper = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(1),
    display: 'flex'
  }
}))(Typography);

export const BreadcrumbsSkeleton = withStyles(({ spacing }) => ({
  root: {
    width: 250,
    height: 21,
    marginTop: spacing(2),
    borderRadius: 4,
    backgroundColor: 'white !important'
  }
}))(Skeleton);

export const SelectedCount = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.primary.main,
    fontWeight: 600,
    cursor: 'pointer',
    marginRight: spacing(3)
  }
}))(Typography);

export const HeaderButton = withStyles(({ spacing }) => ({
  root: {
    borderRadius: 6,
    minWidth: 42,
    padding: spacing(0),
    color: TextColor.SlateGrey,
    border: 'none'
  }
}))(Button);

export const useStyles = makeStyles(({ palette, spacing }) => ({
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2)
  },
  btnsWrapper: {
    height: 40
  },
  breadcrumbIcon: {
    color: palette.text.secondary,
    marginRight: spacing(1)
  },
  breadcrumbLink: {
    textDecoration: 'none',
    color: palette.text.secondary
  },

  activeViewButton: {
    backgroundColor: palette.primary.main,
    color: palette.common.white
  },
  headerButtonWrapper: {
    marginRight: spacing(3)
  },
  goBackWrapper: {
    width: 35,
    height: 35,
    padding: 0,
    minWidth: 'fit-content',
    cursor: 'pointer',
    borderRadius: '50%',
    marginRight: spacing(3)
  },
  viewButton: {
    width: 40,
    maxHeight: 40,
    padding: spacing(0),

    '&.Mui-disabled': {
      opacity: 0.5
    }
  }
}));
